import React from 'react';
import { logoutUser } from '../../redux/actions/user';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Redirect, useLocation } from 'react-router-dom';
import Navbar from '../../components/Navbar';

export function ProtectedRoute(props: any) {
  const location = useLocation();
  const { user } = useSelector((state: any) => ({ user: state.user }));

  const dispatch = useDispatch();
  const { component: Component, ...rest } = props;
  return (
    <Route

      {...rest}
      render={(props) => {
        if (user !== null) {
          if (user.isAuthenticated) {
            return <Component {...props} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: '/login',
                  state: {
                    from: location,
                  },
                }}
              />
            );
          }
        } else {
          // important clears the current user since the data is invalid
          // console.log("LOC: ", location);
          dispatch(logoutUser());
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  from: location,
                },
              }}
            />
          );
        }
      }}
    />
  );
}
